import uhttp from '@/plugins/http'
import { API } from './config'
import fetch from '@/plugins/fetch'
import jsCookie from 'js-cookie'
import utils from '@/plugins/utils'

// 【月嫂端】查询月嫂是否已绑定订单
export const getBindOrder = async () => {
  const response = await uhttp.post(`${API.URL_QUERY_BIND_ORDER}`)
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else if (+code === 4) {
    utils.login()
  } else {
    return Promise.reject(msg)
  }
}

// 【月嫂端】月嫂绑定订单
export const saveBindOrder = async (query) => {
  const response = (await uhttp.post(API.URL_BIND_ORDER, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【【月嫂端】根据用户手机号查是否有效月嫂订单
export const queryYueSaoOrder = async (query) => {
  const response = (await uhttp.post(API.URL_QUERY_YUESAO_ORDER, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【月嫂端】月嫂解除绑定订单
export const saveUnbindOrder = async (query) => {
  const response = (await uhttp.post(API.URL_UNBIND_ORDER, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【月嫂端】月嫂上传日志新增，编辑接口
export const addServiceLog = async params => {
  const res = await fetch(API.URL_UPLOAD_LOG, {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  }) || {}
  const response = await res.json()
  const { code, msg = '网络异常，请刷新重试' } = response
  if (+code === 1) {
    return code
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【月嫂端】根据订单号查日志详情
export const queryYuesaoLogDetail = async (query) => {
  query['uid'] = jsCookie.get('uid') || ''
  const response = (await uhttp.post(API.URL_QUERY_LOG_DETAIL, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【会员端】根据日期查月嫂日志详情
export const queryMemberLogDetail = async (query) => {
  const response = (await uhttp.post(API.URL_QUERY_MEMBER_LOG_DETAIL, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【基础数据】基础数据获取首次惊喜时刻
export const queryBaseData = async () => {
  const response = (await uhttp.get(API.URL_QUERY_BASE_DATA)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【基础数据】根据订单号查订单数据，已上传天数
export const queryOrderData = async (query) => {
  const response = (await uhttp.get(API.URL_QUERY_ORDER_DATA, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1) {
    return data
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}

// 【基础数据】根据订单号查雇主信息
export const queryEmployerInfo = async (query) => {
  const response = (await uhttp.post(API.URL_QUERY_EMPLOYER_INFO, query)) || {}
  const { code, msg = '网络异常，请刷新重试', data = {} } = response
  if (+code === 1 || +code === 10) {
    return response
  } else {
    if (+code === 4) {
      utils.login()
    }
    return Promise.reject(msg)
  }
}
